import React from 'react'

import { useAppSelector } from 'redux/hooks'
import { selectStacks } from 'redux/deck/selectors'

import ImageCard from 'components/card/deckCards/imageCard'
import StickiedDeckControls from 'components/deckPage/filtersAndControls/StickiedDeckControls'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'
import StackHeader from 'components/deckPage/DeckContainerV2/StackHeader'

import { STACK_WIDTH } from '../helperFunctions'
import { useCategoryIsCollapsed } from 'hooks/collapsibleCategories'

import { StackType } from 'types/deck'

import styles from './grid.module.scss'

const GridLayout = () => {
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)

  const imageSize = useAppSelector(state => state.cacheables.imageSize)

  const displaySections = [...mainDeck, ...sideDeck]

  let smallScreenGridOverride = styles.gridOverrideNormal

  if (imageSize === 1) smallScreenGridOverride = styles.gridOverrideSmall
  if (imageSize === 2) smallScreenGridOverride = styles.gridOverrideNormal // posterity: this is the same as the default
  if (imageSize === 3) smallScreenGridOverride = styles.gridOverrideLarge

  return (
    <div className={styles.container}>
      <StickiedDeckControls />
      <div className={styles.content}>
        {displaySections.map((stack, index) => (
          <Grid stack={stack} className={smallScreenGridOverride} key={index} />
        ))}
      </div>
    </div>
  )
}

type GridProps = {
  stack: StackType
  className?: string
}

const Grid = ({ stack, className = '' }: GridProps) => {
  const isCollapsed = useCategoryIsCollapsed(stack.name)

  const imageSize = useAppSelector(state => state.cacheables.imageSize)
  const cardSize = STACK_WIDTH[imageSize]

  return (
    <div className={`${isCollapsed ? styles.collapsed : ''}`}>
      <StackWrapper name={stack.name}>
        <div className={styles.stackHeaderContainer}>
          <StackHeader
            className={styles.stackHeader}
            name={stack.name}
            quantity={stack.quantity}
            mdfcQuantity={stack.mdfcQuantity}
            price={stack.price}
            cardIds={stack.cardIds}
            includeInDeck={stack.includedInDeck}
            includeInPrice={stack.includedInPrice}
            isPremier={stack.isPremier}
          />
        </div>
        {!isCollapsed && (
          <div
            className={`${styles.grid} ${className}`}
            style={{
              gridTemplateColumns: `repeat(auto-fill, minmax(${cardSize}px, 1fr))`,
            }}>
            {stack.cardIds.map(cardId => (
              <ImageCard
                stackName={stack.name}
                key={cardId}
                cardId={cardId}
                className={styles.basicCard}
                basicCardClass={styles.basicCard}
                imageClassName={styles.cardImage}
                wrapperClassName={styles.deckCardWrapper}
              />
            ))}
          </div>
        )}
      </StackWrapper>
    </div>
  )
}

export default GridLayout
